export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.  */
  DateTime: { input: any; output: any }
}

export type _IAddress = {
  city?: Maybe<Scalars['String']['output']>
  complement?: Maybe<Scalars['String']['output']>
  formatted: Scalars['String']['output']
  lat: Scalars['Float']['output']
  lng: Scalars['Float']['output']
  neighborhood?: Maybe<Scalars['String']['output']>
  number: Scalars['String']['output']
  street: Scalars['String']['output']
}

export type _IAmountActionInput = {
  amount: Scalars['Int']['input']
  /** ISO 8601 UTC timestamp */
  timestamp: Scalars['String']['input']
}

export enum _IAssortmentType {
  core = 'core',
  plus = 'plus',
  unknown = 'unknown',
}

export type _IBag = {
  amount: Scalars['Int']['output']
  size: _IBagSize
  type: _IBagType
}

export type _IBagInput = {
  amount: Scalars['Int']['input']
  size: _IBagSize
  type: _IBagType
}

export enum _IBagSize {
  bottle = 'bottle',
  l = 'l',
  paper_bag = 'paper_bag',
  s = 's',
  unknown = 'unknown',
  xl = 'xl',
  xs = 'xs',
}

export enum _IBagType {
  kraft = 'kraft',
  plastic = 'plastic',
  unknown = 'unknown',
}

export type _ICheckMovementDeliveryInput = {
  amountActions: Array<_IAmountActionInput>
  checkedAmount: Scalars['Int']['input']
  movementId: Scalars['String']['input']
}

export type _IChecking = {
  currentShopper?: Maybe<_IPickingShopper>
  id: Scalars['String']['output']
  movementId: Scalars['String']['output']
  reference?: Maybe<_IReferenceUnion>
  shoppers: Array<_IPickingShopper>
  stats: _ICheckingStats
  status: _ICheckingStatus
}

export type _ICheckingItem = {
  exceededAmount: Scalars['Int']['output']
  fulfilledAmount: Scalars['Int']['output']
  id: Scalars['String']['output']
  lineItem: _ILineItem
  missingAmount: Scalars['Int']['output']
  multipleAmount: Scalars['Int']['output']
  status: _ICheckingItemStatus
  unitaryAmount: Scalars['Int']['output']
}

export enum _ICheckingItemKind {
  multiple = 'multiple',
  unit = 'unit',
}

export enum _ICheckingItemStatus {
  checked = 'checked',
  checking = 'checking',
  not_picked = 'not_picked',
  ready_to_check = 'ready_to_check',
  unavailable = 'unavailable',
  waiting_pick = 'waiting_pick',
}

export type _ICheckingStats = {
  checkedAmount: Scalars['Int']['output']
  checkedItems: Scalars['Int']['output']
  remainingItems: Scalars['Int']['output']
  totalAmount: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  unavailableItems: Scalars['Int']['output']
}

export enum _ICheckingStatus {
  canceled = 'canceled',
  checked = 'checked',
  closed = 'closed',
  completed = 'completed',
  in_progress = 'in_progress',
  paused = 'paused',
  ready_to_check = 'ready_to_check',
}

export enum _IClosingOrigin {
  checking = 'checking',
  picking = 'picking',
}

export type _ICompleteMovementCheckingInput = {
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}

export type _ICustomer = {
  address: _IAddress
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  orderCount: Scalars['Int']['output']
}

export type _IDeliveriesPaginated = {
  currentPage: Scalars['Int']['output']
  deliveries: Array<_IDelivery>
  perPage: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalOfPages: Scalars['Int']['output']
}

export type _IDelivery = {
  assortmentType: _IAssortmentType
  bags?: Maybe<Array<_IBag>>
  confirmedAt: Scalars['DateTime']['output']
  customer: _ICustomer
  deliveryType: _IDeliveryType
  dispatch: Scalars['Boolean']['output']
  etaMax?: Maybe<Scalars['DateTime']['output']>
  etaMin?: Maybe<Scalars['DateTime']['output']>
  finishedAt?: Maybe<Scalars['DateTime']['output']>
  hasBags?: Maybe<Scalars['Boolean']['output']>
  hub: _IDeliveryHub
  id: Scalars['String']['output']
  lastPickUpdate?: Maybe<Scalars['DateTime']['output']>
  locationResume?: Maybe<_ILocationResume>
  orderId: Scalars['String']['output']
  products: Array<_IProduct>
  relatedDeliveries: Array<Scalars['String']['output']>
  rider?: Maybe<_IRider>
  shopper?: Maybe<_IShopper>
  shopperHistory: Array<_IShopperHistory>
  status: _IDeliveryStatus
  statusHistory: Array<_IStatusHistory>
  statusItems?: Maybe<_IStatusItems>
  url?: Maybe<Scalars['String']['output']>
}

export type _IDeliveryDetails = {
  assortmentType: _IAssortmentType
  confirmedAt: Scalars['DateTime']['output']
  customer: _ICustomer
  deliveryType: _IDeliveryType
  dispatch: Scalars['Boolean']['output']
  etaMax?: Maybe<Scalars['DateTime']['output']>
  etaMin?: Maybe<Scalars['DateTime']['output']>
  finishedAt?: Maybe<Scalars['DateTime']['output']>
  hub: _IDeliveryHub
  id: Scalars['String']['output']
  orderId: Scalars['String']['output']
  relatedDeliveries: Array<Scalars['String']['output']>
  rider?: Maybe<_IRider>
  shopper?: Maybe<_IShopper>
  shopperHistory: Array<_IShopperHistory>
  status: _IDeliveryStatus
  statusHistory: Array<_IStatusHistory>
  url?: Maybe<Scalars['String']['output']>
}

export type _IDeliveryHub = {
  alias: Scalars['String']['output']
  id: Scalars['String']['output']
}

export enum _IDeliveryStatus {
  arrived = 'arrived',
  canceled = 'canceled',
  delivered = 'delivered',
  on_the_way = 'on_the_way',
  pending = 'pending',
  picked = 'picked',
  picking = 'picking',
  pre_processed = 'pre_processed',
  processed = 'processed',
  ready = 'ready',
  unknown = 'unknown',
}

export enum _IDeliveryType {
  instant = 'instant',
  scheduled = 'scheduled',
  unknown = 'unknown',
}

export type _IFinishDeliveryPackingInput = {
  bags?: InputMaybe<Array<_IBagInput>>
  deliveryId: Scalars['String']['input']
  hubId: Scalars['String']['input']
}

export type _IFinishMovementCheckingInput = {
  checkingId: Scalars['String']['input']
}

export type _IFinishMovementPickingInput = {
  movementId?: InputMaybe<Scalars['String']['input']>
  pickingId?: InputMaybe<Scalars['String']['input']>
}

export type _IFinishMovementsInput = {
  closingOrigin?: InputMaybe<_IClosingOrigin>
  movementIds: Array<Scalars['String']['input']>
}

export type _IFinishMovementsResult = {
  failed: Array<Scalars['String']['output']>
  success: Array<Scalars['String']['output']>
}

export type _IFlagged = {
  amount: Scalars['Float']['output']
  reason: Scalars['String']['output']
}

export type _IFlaggedInput = {
  amount: Scalars['Float']['input']
  reason: Scalars['String']['input']
}

export type _IHub = {
  alias: Scalars['String']['output']
  hubEventcreatedAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
}

export type _ILineItem = {
  amount: Scalars['Float']['output']
  barcodes: Array<Scalars['String']['output']>
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  location: Scalars['String']['output']
  name: Scalars['String']['output']
  sku: Scalars['String']['output']
  tags: Array<Scalars['String']['output']>
  totalAmountPerBox?: Maybe<Scalars['Int']['output']>
}

export type _ILiveChecking = {
  checking: _IChecking
  event: Scalars['String']['output']
}

export type _ILiveCheckingItem = {
  checkingItem: _ICheckingItem
  event: Scalars['String']['output']
}

export type _ILiveDeliveriesReturn = {
  delivery: _IDelivery
  event: Scalars['String']['output']
}

export type _ILiveMovementReturn = {
  event: Scalars['String']['output']
  movement: _IPickingMovement
}

export type _ILivePickingItem = {
  event: Scalars['String']['output']
  pickingItem: _IPickingItem
}

export type _ILocationResume = {
  location?: Maybe<Scalars['String']['output']>
  shelves?: Maybe<_ILocationResumeShelves>
  totalOfFresh?: Maybe<Scalars['Int']['output']>
  totalOfFrozen?: Maybe<Scalars['Int']['output']>
  totalOfRefrigerated?: Maybe<Scalars['Int']['output']>
  totalOfRoomTemperature?: Maybe<Scalars['Int']['output']>
}

export type _ILocationResumeInput = {
  shelves?: InputMaybe<_ILocationResumeShelfInput>
}

export type _ILocationResumeShelfInput = {
  fresh?: InputMaybe<_ILocationResumeShelfStatus>
  frozen?: InputMaybe<_ILocationResumeShelfStatus>
  refrigerated?: InputMaybe<_ILocationResumeShelfStatus>
  roomTemperature?: InputMaybe<_ILocationResumeShelfStatus>
}

export enum _ILocationResumeShelfStatus {
  collected = 'collected',
  not_collected = 'not_collected',
  not_in_use = 'not_in_use',
  unknown = 'unknown',
}

export type _ILocationResumeShelves = {
  fresh?: Maybe<_ILocationResumeShelfStatus>
  frozen?: Maybe<_ILocationResumeShelfStatus>
  refrigerated?: Maybe<_ILocationResumeShelfStatus>
  roomTemperature?: Maybe<_ILocationResumeShelfStatus>
}

export enum _IManualPickActionReason {
  noBarcode = 'noBarcode',
  notReadBarcode = 'notReadBarcode',
}

export type _IManualPickReasonsInput = {
  amount: Scalars['Int']['input']
  reason: _IManualPickActionReason
}

export type _IManually = {
  amount: Scalars['Float']['output']
  reason: Scalars['String']['output']
}

export type _IManuallyInput = {
  amount: Scalars['Float']['input']
  reason: Scalars['String']['input']
}

export enum _IMovementPickingCheckStatus {
  all_sent_to_check = 'all_sent_to_check',
  checking_closed = 'checking_closed',
  none_sent_to_check = 'none_sent_to_check',
  some_sent_to_check = 'some_sent_to_check',
}

export enum _IMovementStatus {
  canceled = 'canceled',
  fulfilled = 'fulfilled',
  marked_fulfilled = 'marked_fulfilled',
  open = 'open',
  unknown = 'unknown',
}

export type _IMovementsForCheckingPaginated = {
  checkings: Array<_IChecking>
  currentPage: Scalars['Int']['output']
  perPage: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalOfPages: Scalars['Int']['output']
}

export type _IMovementsPaginated = {
  currentPage: Scalars['Int']['output']
  movements: Array<_IPickingMovement>
  perPage: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalOfPages: Scalars['Int']['output']
}

export type _IMutation = {
  checkMovementDelivery: Scalars['Boolean']['output']
  completeMovementChecking: Scalars['Boolean']['output']
  createShopper: _IShopperResponse
  finishDeliveryPacking: Scalars['Boolean']['output']
  finishMovementChecking: Scalars['Boolean']['output']
  finishMovementPacking: Scalars['Boolean']['output']
  finishMovementPicking: Scalars['Boolean']['output']
  finishMovements: _IFinishMovementsResult
  pauseMovementChecking: Scalars['Boolean']['output']
  sendToCheck: _ISendToCheckResult
  signinShopper: Scalars['Boolean']['output']
  startMovementChecking: Scalars['Boolean']['output']
  startMovementPicking: Scalars['Boolean']['output']
  updateCheckingItem: _ICheckingItem
  updateDelivery: _IDelivery
  updateDeliveryPicking: _IDelivery
  updatePickingItem: _IPickingItem
}

export type _IMutationCheckMovementDeliveryArgs = {
  input: _ICheckMovementDeliveryInput
}

export type _IMutationCompleteMovementCheckingArgs = {
  input: _ICompleteMovementCheckingInput
}

export type _IMutationCreateShopperArgs = {
  data: _IShopperCreateInput
}

export type _IMutationFinishDeliveryPackingArgs = {
  data: _IFinishDeliveryPackingInput
}

export type _IMutationFinishMovementCheckingArgs = {
  input: _IFinishMovementCheckingInput
}

export type _IMutationFinishMovementPackingArgs = {
  input: _IPackingInput
}

export type _IMutationFinishMovementPickingArgs = {
  input: _IFinishMovementPickingInput
}

export type _IMutationFinishMovementsArgs = {
  input: _IFinishMovementsInput
}

export type _IMutationPauseMovementCheckingArgs = {
  input: _IPauseMovementCheckingInput
}

export type _IMutationSendToCheckArgs = {
  input: _ISendToCheckInput
}

export type _IMutationSigninShopperArgs = {
  data: _IShopperSigninInput
}

export type _IMutationStartMovementCheckingArgs = {
  input: _IStartMovementCheckingInput
}

export type _IMutationStartMovementPickingArgs = {
  input: _IStartMovementPickingInput
}

export type _IMutationUpdateCheckingItemArgs = {
  input: _IUpdateCheckingItemInput
}

export type _IMutationUpdateDeliveryArgs = {
  delivery: _IUpdateDeliveryInput
  hubId: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type _IMutationUpdateDeliveryPickingArgs = {
  delivery: _IUpdateDeliveryPickingInput
  hubId: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type _IMutationUpdatePickingItemArgs = {
  input: _IUpdatePickingItemInput
}

export type _IPackingBagInput = {
  amount: Scalars['Int']['input']
  size: _IBagSize
  type: _IBagType
}

export type _IPackingInput = {
  bags?: InputMaybe<Array<_IPackingBagInput>>
  movementId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}

export type _IPauseMovementCheckingInput = {
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}

export type _IPicking = {
  currentShopper?: Maybe<_IPickingShopper>
  id: Scalars['String']['output']
  label: Scalars['String']['output']
  shoppers: Array<_IPickingShopper>
  stats: _IPickingStats
  status: _IPickingStatus
}

export type _IPickingItem = {
  id: Scalars['String']['output']
  isIncorrectLocation: Scalars['Boolean']['output']
  lineItem: _ILineItem
  manualAmount: Scalars['Int']['output']
  manualPickReasons: Array<_IManualPickReasons>
  scannedAmount: Scalars['Int']['output']
  skippedCount: Scalars['Int']['output']
  status: _IPickingItemStatus
  unavailableAmount: Scalars['Int']['output']
  unavailablePickReasons: Array<_IUnavailablePickReasons>
}

export enum _IPickingItemStatus {
  not_picked = 'not_picked',
  picked = 'picked',
  skipped = 'skipped',
  unavailable = 'unavailable',
}

export type _IPickingItemsInput = {
  movementId: Scalars['String']['input']
  pickingId?: InputMaybe<Scalars['String']['input']>
}

export type _IPickingMovement = {
  checkingStatus: _IMovementPickingCheckStatus
  id: Scalars['String']['output']
  reference?: Maybe<_IReferenceUnion>
  stats: _IPickingStats
  status: _IMovementStatus
}

export type _IPickingShopper = {
  code: Scalars['String']['output']
  fullName: Scalars['String']['output']
}

export type _IPickingStats = {
  fulfilledAmount: Scalars['Int']['output']
  startedItems: Scalars['Int']['output']
  totalAmount: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  unavailableItems: Scalars['Int']['output']
}

export enum _IPickingStatus {
  in_progress = 'in_progress',
  partially_picked = 'partially_picked',
  pending = 'pending',
  picked = 'picked',
  sent_to_check = 'sent_to_check',
  unknown = 'unknown',
}

export type _IProduct = {
  _id?: Maybe<Scalars['String']['output']>
  amount?: Maybe<Scalars['Float']['output']>
  barcodes?: Maybe<Array<Scalars['String']['output']>>
  description?: Maybe<Scalars['String']['output']>
  flagged?: Maybe<Array<_IFlagged>>
  flaggedAmount?: Maybe<Scalars['Float']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  incorrectLocation?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  manually?: Maybe<Array<_IManually>>
  manuallyAmount?: Maybe<Scalars['Float']['output']>
  name?: Maybe<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  scannedAmount?: Maybe<Scalars['Float']['output']>
  scanningTime?: Maybe<Scalars['DateTime']['output']>
  sku?: Maybe<Scalars['String']['output']>
  status: _IProductStatus
  tags?: Maybe<Array<Scalars['String']['output']>>
}

export type _IProductInput = {
  _id: Scalars['String']['input']
  flagged?: InputMaybe<Array<_IFlaggedInput>>
  incorrectLocation?: InputMaybe<Scalars['Boolean']['input']>
  manually?: InputMaybe<Array<_IManuallyInput>>
  scannedAmount?: InputMaybe<Scalars['Float']['input']>
}

export enum _IProductStatus {
  in_progress = 'in_progress',
  pending = 'pending',
  picked = 'picked',
  unknown = 'unknown',
}

export type _IQuery = {
  allHubs?: Maybe<Array<_IHub>>
  checkingItems: Array<_ICheckingItem>
  deliveries?: Maybe<Array<_IDelivery>>
  delivery?: Maybe<_IDelivery>
  hub?: Maybe<_IHub>
  hubs?: Maybe<Array<_IHub>>
  incompleteDeliveries?: Maybe<Array<_IDelivery>>
  movementForChecking?: Maybe<_IChecking>
  movementForPicking?: Maybe<_IPickingMovement>
  movementPicking: _IPicking
  movementPickings: Array<_IPicking>
  movementsForCheckingPaginated: _IMovementsForCheckingPaginated
  movementsForPicking?: Maybe<Array<_IPickingMovement>>
  movementsForPickingPaginated: _IMovementsPaginated
  paginatedDeliveries?: Maybe<_IDeliveriesPaginated>
  paginatedDeliveriesByEta?: Maybe<_IDeliveriesPaginated>
  pickingItems: Array<_IPickingItem>
}

export type _IQueryCheckingItemsArgs = {
  checkingId: Scalars['String']['input']
}

export type _IQueryDeliveriesArgs = {
  hubId: Scalars['String']['input']
}

export type _IQueryDeliveryArgs = {
  hubId: Scalars['String']['input']
  orderId: Scalars['String']['input']
}

export type _IQueryHubArgs = {
  id: Scalars['String']['input']
}

export type _IQueryIncompleteDeliveriesArgs = {
  hubId: Scalars['String']['input']
}

export type _IQueryMovementForCheckingArgs = {
  checkingId: Scalars['String']['input']
  hubId: Scalars['String']['input']
}

export type _IQueryMovementForPickingArgs = {
  hubId: Scalars['String']['input']
  movementId: Scalars['String']['input']
}

export type _IQueryMovementPickingArgs = {
  id: Scalars['String']['input']
}

export type _IQueryMovementPickingsArgs = {
  movementId: Scalars['String']['input']
}

export type _IQueryMovementsForCheckingPaginatedArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  hubDestinationId?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  originHubId: Scalars['String']['input']
  referenceId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<_ICheckingStatus>>
}

export type _IQueryMovementsForPickingArgs = {
  deliveryStatuses?: InputMaybe<Array<_IDeliveryStatus>>
  originHubId: Scalars['String']['input']
  referenceType: _IReferenceType
  status?: InputMaybe<_IMovementStatus>
}

export type _IQueryMovementsForPickingPaginatedArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  deliveryStatuses?: InputMaybe<Array<_IDeliveryStatus>>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  hubDestinationId?: InputMaybe<Scalars['String']['input']>
  kind: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  orderId?: InputMaybe<Scalars['String']['input']>
  originHubId: Scalars['String']['input']
  referenceId?: InputMaybe<Scalars['String']['input']>
  referenceType: _IReferenceType
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type _IQueryPaginatedDeliveriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  hubId: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  orderId?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  status: _IDeliveryStatus
}

export type _IQueryPaginatedDeliveriesByEtaArgs = {
  assortmentType: _IAssortmentType
  currentPage?: InputMaybe<Scalars['Int']['input']>
  deliveryType: _IDeliveryType
  etaEndDate?: InputMaybe<Scalars['DateTime']['input']>
  etaStartDate?: InputMaybe<Scalars['DateTime']['input']>
  hubId: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  status: _IDeliveryStatus
}

export type _IQueryPickingItemsArgs = {
  input: _IPickingItemsInput
}

export type _IReferenceDelivery = {
  deliveryDetails: _IDeliveryDetails
  id: Scalars['String']['output']
  referenceType: _IReferenceType
}

export type _IReferenceTransferOrder = {
  destination: _ISource
  id: Scalars['String']['output']
  kind: _ITransferOrderKind
  referenceType: _IReferenceType
  storageType: _ITransferOrderStorageType
}

export enum _IReferenceType {
  delivery = 'delivery',
  transfer_order = 'transfer_order',
  unknown = 'unknown',
}

export type _IReferenceUnion = _IReferenceDelivery | _IReferenceTransferOrder

export type _IRider = {
  fullName: Scalars['String']['output']
  id: Scalars['String']['output']
  mode: _IRiderMode
}

export enum _IRiderMode {
  automatic = 'automatic',
  external = 'external',
  manual = 'manual',
  unknown = 'unknown',
}

export type _ISendToCheckInput = {
  movementId: Scalars['String']['input']
  pickingIds: Array<Scalars['String']['input']>
}

export type _ISendToCheckResult = {
  failed: Array<Scalars['String']['output']>
  success: Array<Scalars['String']['output']>
}

export type _IShopper = {
  code?: Maybe<Scalars['String']['output']>
  cpf?: Maybe<Scalars['String']['output']>
  fullName: Scalars['String']['output']
  id?: Maybe<Scalars['String']['output']>
}

export type _IShopperCreateInput = {
  code: Scalars['String']['input']
  cpf: Scalars['String']['input']
  fullName: Scalars['String']['input']
}

export type _IShopperHistory = {
  code?: Maybe<Scalars['String']['output']>
  cpf?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type _IShopperInput = {
  code?: InputMaybe<Scalars['String']['input']>
  cpf?: InputMaybe<Scalars['String']['input']>
  fullName: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
}

export type _IShopperResponse = {
  code: Scalars['String']['output']
  cpf: Scalars['String']['output']
  fullName: Scalars['String']['output']
}

export type _IShopperSigninInput = {
  code: Scalars['String']['input']
  hubId: Scalars['String']['input']
  orderId: Scalars['String']['input']
}

export type _ISource = {
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type _IStartMovementCheckingInput = {
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}

export type _IStartMovementPickingInput = {
  movementId?: InputMaybe<Scalars['String']['input']>
  pickingId?: InputMaybe<Scalars['String']['input']>
  shopperCode: Scalars['String']['input']
}

export type _IStatusHistory = {
  statusFrom: Scalars['String']['output']
  statusTo: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type _IStatusHistoryInput = {
  statusFrom: _IDeliveryStatus
  statusTo: _IDeliveryStatus
  updatedAt: Scalars['DateTime']['input']
}

export type _IStatusItems = {
  flagged: Scalars['Int']['output']
  manual: Scalars['Int']['output']
  scanned: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalPicked: Scalars['Int']['output']
}

export type _ISubscription = {
  liveDeliveriesUpdated: _ILiveDeliveriesReturn
  liveMovementCheckingItemListUpdated: _ILiveCheckingItem
  liveMovementCheckingItemUpdated: _ILiveCheckingItem
  liveMovementCheckingListUpdated: _ILiveChecking
  liveMovementCheckingUpdated: _IChecking
  liveMovementListUpdated: _ILiveMovementReturn
  liveMovementPickingItemListUpdated: _ILivePickingItem
  liveMovementPickingItemUpdated: _ILivePickingItem
  liveMovementPickingListUpdated: _IPicking
  liveMovementPickingUpdated: _IPicking
  liveMovementUpdated: _IPickingMovement
}

export type _ISubscriptionLiveDeliveriesUpdatedArgs = {
  hubId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementCheckingItemListUpdatedArgs = {
  checkingId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementCheckingItemUpdatedArgs = {
  id: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementCheckingListUpdatedArgs = {
  originHubId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementCheckingUpdatedArgs = {
  id: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementListUpdatedArgs = {
  originHubId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementPickingItemListUpdatedArgs = {
  pickingId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementPickingItemUpdatedArgs = {
  id: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementPickingListUpdatedArgs = {
  movementId: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementPickingUpdatedArgs = {
  id: Scalars['String']['input']
}

export type _ISubscriptionLiveMovementUpdatedArgs = {
  id: Scalars['String']['input']
}

export enum _ITransferOrderKind {
  cross_docking = 'cross_docking',
  fresh_cross_docking_flv = 'fresh_cross_docking_flv',
  fresh_cross_docking_non_flv = 'fresh_cross_docking_non_flv',
  hub_to_hub = 'hub_to_hub',
  internal_replenishment = 'internal_replenishment',
  plus = 'plus',
  receive_and_stow = 'receive_and_stow',
  reverse_to = 'reverse_to',
  unknown = 'unknown',
}

export enum _ITransferOrderStorageType {
  frozen = 'frozen',
  room_temperature = 'room_temperature',
  unknown = 'unknown',
}

export enum _IUnavailablePickActionReason {
  productNotSuitableForShipping = 'productNotSuitableForShipping',
  productOutOfStock = 'productOutOfStock',
}

export type _IUnavailablePickReasonsInput = {
  amount: Scalars['Int']['input']
  reason: _IUnavailablePickActionReason
}

export type _IUpdateCheckingItemInput = {
  amount: Scalars['Int']['input']
  checkingId: Scalars['String']['input']
  checkingItemId: Scalars['String']['input']
  code: Scalars['String']['input']
  kind: _ICheckingItemKind
}

export type _IUpdateDeliveryInput = {
  lastPickUpdate?: InputMaybe<Scalars['DateTime']['input']>
  locationResume?: InputMaybe<_ILocationResumeInput>
  status?: InputMaybe<_IDeliveryStatus>
  statusHistory?: InputMaybe<Array<_IStatusHistoryInput>>
}

export type _IUpdateDeliveryPickingInput = {
  product?: InputMaybe<_IProductInput>
  shopper?: InputMaybe<_IShopperInput>
  status?: InputMaybe<_IDeliveryStatus>
}

export type _IUpdatePickingItemInput = {
  hubId: Scalars['String']['input']
  isIncorrectLocation?: Scalars['Boolean']['input']
  isSkip?: Scalars['Boolean']['input']
  isUnavailable?: Scalars['Boolean']['input']
  manualAmount?: Scalars['Int']['input']
  manualPickReasonsInput?: Array<_IManualPickReasonsInput>
  pickingItemId: Scalars['String']['input']
  scannedAmount: Scalars['Int']['input']
  shopperCode: Scalars['String']['input']
  unavailablePickReasonsInput?: Array<_IUnavailablePickReasonsInput>
}

export type _IManualPickReasons = {
  amount: Scalars['Int']['output']
  reason: _IManualPickActionReason
}

export type _IUnavailablePickReasons = {
  amount: Scalars['Int']['output']
  reason: _IUnavailablePickActionReason
}

export type _ICheckingItemFieldsFragment = {
  __typename: 'CheckingItem'
  id: string
  status: _ICheckingItemStatus
  fulfilledAmount: number
  missingAmount: number
  exceededAmount: number
  lineItem: {
    __typename: 'LineItem'
    sku: string
    name: string
    amount: number
    location: string
    totalAmountPerBox?: number | null
    barcodes: Array<string>
    imageUrl?: string | null
    tags: Array<string>
  }
}

export type _IDeliveriesPaginatedFieldsFragment = {
  currentPage: number
  perPage: number
  totalOfPages: number
  total: number
  deliveries: Array<{
    __typename: 'Delivery'
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMin?: any | null
    etaMax?: any | null
    dispatch: boolean
    finishedAt?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hasBags?: boolean | null
    lastPickUpdate?: any | null
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
        city?: string | null
      }
    }
    rider?: { fullName: string; mode: _IRiderMode } | null
    shopper?: { fullName: string } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
    products: Array<{
      _id?: string | null
      name?: string | null
      sku?: string | null
      amount?: number | null
      location?: string | null
      barcodes?: Array<string> | null
      imageUrl?: string | null
      tags?: Array<string> | null
      salesforceId?: string | null
      scanningTime?: any | null
      scannedAmount?: number | null
      manuallyAmount?: number | null
      flaggedAmount?: number | null
      incorrectLocation?: boolean | null
      status: _IProductStatus
      flagged?: Array<{ reason: string; amount: number }> | null
      manually?: Array<{ reason: string; amount: number }> | null
    }>
    statusItems?: {
      total: number
      scanned: number
      manual: number
      flagged: number
      totalPicked: number
    } | null
    bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
    locationResume?: {
      totalOfRefrigerated?: number | null
      totalOfFrozen?: number | null
      totalOfRoomTemperature?: number | null
      totalOfFresh?: number | null
      location?: string | null
      shelves?: {
        fresh?: _ILocationResumeShelfStatus | null
        frozen?: _ILocationResumeShelfStatus | null
        refrigerated?: _ILocationResumeShelfStatus | null
        roomTemperature?: _ILocationResumeShelfStatus | null
      } | null
    } | null
  }>
}

export type _IDeliveryFieldsFragment = {
  __typename: 'Delivery'
  id: string
  status: _IDeliveryStatus
  orderId: string
  confirmedAt: any
  etaMin?: any | null
  etaMax?: any | null
  dispatch: boolean
  finishedAt?: any | null
  assortmentType: _IAssortmentType
  deliveryType: _IDeliveryType
  relatedDeliveries: Array<string>
  hasBags?: boolean | null
  lastPickUpdate?: any | null
  hub: { id: string; alias: string }
  customer: {
    name: string
    orderCount: number
    address: {
      formatted: string
      street: string
      number: string
      complement?: string | null
      neighborhood?: string | null
      city?: string | null
    }
  }
  rider?: { fullName: string; mode: _IRiderMode } | null
  shopper?: { fullName: string } | null
  statusHistory: Array<{
    statusFrom: string
    statusTo: string
    updatedAt?: any | null
  }>
  products: Array<{
    _id?: string | null
    name?: string | null
    sku?: string | null
    amount?: number | null
    location?: string | null
    barcodes?: Array<string> | null
    imageUrl?: string | null
    tags?: Array<string> | null
    salesforceId?: string | null
    scanningTime?: any | null
    scannedAmount?: number | null
    manuallyAmount?: number | null
    flaggedAmount?: number | null
    incorrectLocation?: boolean | null
    status: _IProductStatus
    flagged?: Array<{ reason: string; amount: number }> | null
    manually?: Array<{ reason: string; amount: number }> | null
  }>
  statusItems?: {
    total: number
    scanned: number
    manual: number
    flagged: number
    totalPicked: number
  } | null
  bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
  locationResume?: {
    totalOfRefrigerated?: number | null
    totalOfFrozen?: number | null
    totalOfRoomTemperature?: number | null
    totalOfFresh?: number | null
    location?: string | null
    shelves?: {
      fresh?: _ILocationResumeShelfStatus | null
      frozen?: _ILocationResumeShelfStatus | null
      refrigerated?: _ILocationResumeShelfStatus | null
      roomTemperature?: _ILocationResumeShelfStatus | null
    } | null
  } | null
}

export type _ILineItemFieldsFragment = {
  __typename: 'LineItem'
  sku: string
  name: string
  amount: number
  location: string
  totalAmountPerBox?: number | null
  barcodes: Array<string>
  imageUrl?: string | null
  tags: Array<string>
}

export type _IMovementDeliveryForPickingFieldsFragment = {
  __typename: 'PickingMovement'
  id: string
  status: _IMovementStatus
  reference?:
    | {
        __typename: 'ReferenceDelivery'
        id: string
        referenceType: _IReferenceType
        deliveryDetails: {
          id: string
          status: _IDeliveryStatus
          orderId: string
          confirmedAt: any
          etaMax?: any | null
          etaMin?: any | null
          assortmentType: _IAssortmentType
          deliveryType: _IDeliveryType
          relatedDeliveries: Array<string>
          hub: { id: string; alias: string }
          customer: {
            name: string
            orderCount: number
            address: {
              formatted: string
              street: string
              number: string
              complement?: string | null
              neighborhood?: string | null
            }
          }
          rider?: { fullName: string } | null
          shopper?: { fullName: string; code?: string | null } | null
          statusHistory: Array<{
            statusFrom: string
            statusTo: string
            updatedAt?: any | null
          }>
        }
      }
    | {}
    | null
  stats: { totalAmount: number; totalItems: number; fulfilledAmount: number }
}

export type _IMovementForCheckingFieldsFragment = {
  __typename: 'Checking'
  id: string
  status: _ICheckingStatus
  movementId: string
  currentShopper?: { code: string } | null
  shoppers: Array<{ code: string; fullName: string }>
  reference?:
    | {
        id: string
        referenceType: _IReferenceType
        kind: _ITransferOrderKind
        storageType: _ITransferOrderStorageType
        destination: { id: string; name: string }
      }
    | {}
    | null
  stats: {
    checkedAmount: number
    checkedItems: number
    unavailableItems: number
    totalAmount: number
    totalItems: number
    remainingItems: number
  }
}

export type _IMovementForPickingFieldsFragment = {
  __typename: 'PickingMovement'
  id: string
  status: _IMovementStatus
  checkingStatus: _IMovementPickingCheckStatus
  reference?:
    | {
        id: string
        referenceType: _IReferenceType
        kind: _ITransferOrderKind
        storageType: _ITransferOrderStorageType
        destination: { id: string; name: string }
      }
    | {}
    | null
  stats: {
    fulfilledAmount: number
    totalAmount: number
    startedItems: number
    unavailableItems: number
    totalItems: number
  }
}

export type _IMovementPickingFieldsFragment = {
  __typename: 'Picking'
  id: string
  label: string
  status: _IPickingStatus
  shoppers: Array<{ fullName: string }>
  stats: {
    fulfilledAmount: number
    totalAmount: number
    startedItems: number
    unavailableItems: number
    totalItems: number
  }
  currentShopper?: { code: string } | null
}

export type _IMovementsDeliveriesPaginatedFieldsFragment = {
  __typename: 'MovementsPaginated'
  currentPage: number
  perPage: number
  totalOfPages: number
  total: number
  movements: Array<{
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    reference?:
      | {
          __typename: 'ReferenceDelivery'
          id: string
          referenceType: _IReferenceType
          deliveryDetails: {
            id: string
            status: _IDeliveryStatus
            orderId: string
            confirmedAt: any
            etaMax?: any | null
            etaMin?: any | null
            assortmentType: _IAssortmentType
            deliveryType: _IDeliveryType
            relatedDeliveries: Array<string>
            hub: { id: string; alias: string }
            customer: {
              name: string
              orderCount: number
              address: {
                formatted: string
                street: string
                number: string
                complement?: string | null
                neighborhood?: string | null
              }
            }
            rider?: { fullName: string } | null
            shopper?: { fullName: string; code?: string | null } | null
            statusHistory: Array<{
              statusFrom: string
              statusTo: string
              updatedAt?: any | null
            }>
          }
        }
      | {}
      | null
    stats: { totalAmount: number; totalItems: number; fulfilledAmount: number }
  }>
}

export type _IMovementsForCheckingPaginatedFieldsFragment = {
  __typename: 'MovementsForCheckingPaginated'
  currentPage: number
  perPage: number
  totalOfPages: number
  total: number
  checkings: Array<{
    __typename: 'Checking'
    id: string
    status: _ICheckingStatus
    movementId: string
    currentShopper?: { code: string } | null
    shoppers: Array<{ code: string; fullName: string }>
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      checkedAmount: number
      checkedItems: number
      unavailableItems: number
      totalAmount: number
      totalItems: number
      remainingItems: number
    }
  }>
}

export type _IMovementsPaginatedFieldsFragment = {
  __typename: 'MovementsPaginated'
  currentPage: number
  perPage: number
  totalOfPages: number
  total: number
  movements: Array<{
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    checkingStatus: _IMovementPickingCheckStatus
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
  }>
}

export type _IPickingItemFieldsFragment = {
  __typename: 'PickingItem'
  id: string
  status: _IPickingItemStatus
  manualAmount: number
  scannedAmount: number
  skippedCount: number
  unavailableAmount: number
  isIncorrectLocation: boolean
  lineItem: {
    __typename: 'LineItem'
    sku: string
    name: string
    amount: number
    location: string
    totalAmountPerBox?: number | null
    barcodes: Array<string>
    imageUrl?: string | null
    tags: Array<string>
  }
  unavailablePickReasons: Array<{
    reason: _IUnavailablePickActionReason
    amount: number
  }>
  manualPickReasons: Array<{ reason: _IManualPickActionReason; amount: number }>
}

export type _IReferenceDeliveryFieldsFragment = {
  __typename: 'ReferenceDelivery'
  id: string
  referenceType: _IReferenceType
  deliveryDetails: {
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMax?: any | null
    etaMin?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
      }
    }
    rider?: { fullName: string } | null
    shopper?: { fullName: string; code?: string | null } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
  }
}

export type _IReferenceTransferOrderFieldsFragment = {
  id: string
  referenceType: _IReferenceType
  kind: _ITransferOrderKind
  storageType: _ITransferOrderStorageType
  destination: { id: string; name: string }
}

export type _ICheckMovementDeliveryMutationVariables = Exact<{
  movementId: Scalars['String']['input']
  checkedAmount: Scalars['Int']['input']
  amountActions: Array<_IAmountActionInput> | _IAmountActionInput
}>

export type _ICheckMovementDeliveryMutation = { checkMovementDelivery: boolean }

export type _ICloseMovementsMutationVariables = Exact<{
  movementIds: Array<Scalars['String']['input']> | Scalars['String']['input']
  closingOrigin?: InputMaybe<_IClosingOrigin>
}>

export type _ICloseMovementsMutation = {
  finishMovements: { success: Array<string>; failed: Array<string> }
}

export type _ICompleteMovementCheckingMutationVariables = Exact<{
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}>

export type _ICompleteMovementCheckingMutation = {
  completeMovementChecking: boolean
}

export type _IFinishDeliveryPackingMutationVariables = Exact<{
  id: Scalars['String']['input']
  hubId: Scalars['String']['input']
  bags?: InputMaybe<Array<_IBagInput> | _IBagInput>
}>

export type _IFinishDeliveryPackingMutation = { finishDeliveryPacking: boolean }

export type _IFinishMovementCheckingMutationVariables = Exact<{
  checkingId: Scalars['String']['input']
}>

export type _IFinishMovementCheckingMutation = {
  finishMovementChecking: boolean
}

export type _IFinishMovementPackingMutationVariables = Exact<{
  movementId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
  bags?: InputMaybe<Array<_IPackingBagInput> | _IPackingBagInput>
}>

export type _IFinishMovementPackingMutation = { finishMovementPacking: boolean }

export type _IFinishMovementPickingMutationVariables = Exact<{
  pickingId?: InputMaybe<Scalars['String']['input']>
  movementId?: InputMaybe<Scalars['String']['input']>
}>

export type _IFinishMovementPickingMutation = { finishMovementPicking: boolean }

export type _IPauseMovementCheckingMutationVariables = Exact<{
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}>

export type _IPauseMovementCheckingMutation = { pauseMovementChecking: boolean }

export type _ISendToCheckMutationVariables = Exact<{
  pickingIds: Array<Scalars['String']['input']> | Scalars['String']['input']
  movementId: Scalars['String']['input']
}>

export type _ISendToCheckMutation = {
  sendToCheck: { success: Array<string>; failed: Array<string> }
}

export type _ISetSignInShopperMutationVariables = Exact<{
  hubId: Scalars['String']['input']
  orderId: Scalars['String']['input']
  code: Scalars['String']['input']
}>

export type _ISetSignInShopperMutation = { signinShopper: boolean }

export type _IStartMovementCheckingMutationVariables = Exact<{
  checkingId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
}>

export type _IStartMovementCheckingMutation = { startMovementChecking: boolean }

export type _IStartMovementPickingMutationVariables = Exact<{
  pickingId?: InputMaybe<Scalars['String']['input']>
  movementId?: InputMaybe<Scalars['String']['input']>
  shopperCode: Scalars['String']['input']
}>

export type _IStartMovementPickingMutation = { startMovementPicking: boolean }

export type _IUpdateCheckingItemMutationVariables = Exact<{
  checkingId: Scalars['String']['input']
  checkingItemId: Scalars['String']['input']
  code: Scalars['String']['input']
  amount: Scalars['Int']['input']
  kind: _ICheckingItemKind
}>

export type _IUpdateCheckingItemMutation = {
  updateCheckingItem: {
    __typename: 'CheckingItem'
    id: string
    status: _ICheckingItemStatus
    fulfilledAmount: number
    missingAmount: number
    exceededAmount: number
    lineItem: {
      __typename: 'LineItem'
      sku: string
      name: string
      amount: number
      location: string
      totalAmountPerBox?: number | null
      barcodes: Array<string>
      imageUrl?: string | null
      tags: Array<string>
    }
  }
}

export type _IUpdateDeliveryPickingMutationVariables = Exact<{
  id: Scalars['String']['input']
  hubId: Scalars['String']['input']
  delivery: _IUpdateDeliveryPickingInput
}>

export type _IUpdateDeliveryPickingMutation = {
  updateDeliveryPicking: {
    __typename: 'Delivery'
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMin?: any | null
    etaMax?: any | null
    dispatch: boolean
    finishedAt?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hasBags?: boolean | null
    lastPickUpdate?: any | null
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
        city?: string | null
      }
    }
    rider?: { fullName: string; mode: _IRiderMode } | null
    shopper?: { fullName: string } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
    products: Array<{
      _id?: string | null
      name?: string | null
      sku?: string | null
      amount?: number | null
      location?: string | null
      barcodes?: Array<string> | null
      imageUrl?: string | null
      tags?: Array<string> | null
      salesforceId?: string | null
      scanningTime?: any | null
      scannedAmount?: number | null
      manuallyAmount?: number | null
      flaggedAmount?: number | null
      incorrectLocation?: boolean | null
      status: _IProductStatus
      flagged?: Array<{ reason: string; amount: number }> | null
      manually?: Array<{ reason: string; amount: number }> | null
    }>
    statusItems?: {
      total: number
      scanned: number
      manual: number
      flagged: number
      totalPicked: number
    } | null
    bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
    locationResume?: {
      totalOfRefrigerated?: number | null
      totalOfFrozen?: number | null
      totalOfRoomTemperature?: number | null
      totalOfFresh?: number | null
      location?: string | null
      shelves?: {
        fresh?: _ILocationResumeShelfStatus | null
        frozen?: _ILocationResumeShelfStatus | null
        refrigerated?: _ILocationResumeShelfStatus | null
        roomTemperature?: _ILocationResumeShelfStatus | null
      } | null
    } | null
  }
}

export type _IUpdateDeliveryMutationVariables = Exact<{
  id: Scalars['String']['input']
  hubId: Scalars['String']['input']
  delivery: _IUpdateDeliveryInput
}>

export type _IUpdateDeliveryMutation = {
  updateDelivery: {
    __typename: 'Delivery'
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMin?: any | null
    etaMax?: any | null
    dispatch: boolean
    finishedAt?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hasBags?: boolean | null
    lastPickUpdate?: any | null
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
        city?: string | null
      }
    }
    rider?: { fullName: string; mode: _IRiderMode } | null
    shopper?: { fullName: string } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
    products: Array<{
      _id?: string | null
      name?: string | null
      sku?: string | null
      amount?: number | null
      location?: string | null
      barcodes?: Array<string> | null
      imageUrl?: string | null
      tags?: Array<string> | null
      salesforceId?: string | null
      scanningTime?: any | null
      scannedAmount?: number | null
      manuallyAmount?: number | null
      flaggedAmount?: number | null
      incorrectLocation?: boolean | null
      status: _IProductStatus
      flagged?: Array<{ reason: string; amount: number }> | null
      manually?: Array<{ reason: string; amount: number }> | null
    }>
    statusItems?: {
      total: number
      scanned: number
      manual: number
      flagged: number
      totalPicked: number
    } | null
    bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
    locationResume?: {
      totalOfRefrigerated?: number | null
      totalOfFrozen?: number | null
      totalOfRoomTemperature?: number | null
      totalOfFresh?: number | null
      location?: string | null
      shelves?: {
        fresh?: _ILocationResumeShelfStatus | null
        frozen?: _ILocationResumeShelfStatus | null
        refrigerated?: _ILocationResumeShelfStatus | null
        roomTemperature?: _ILocationResumeShelfStatus | null
      } | null
    } | null
  }
}

export type _IUpdatePickingItemMutationVariables = Exact<{
  pickingItemId: Scalars['String']['input']
  manualAmount?: InputMaybe<Scalars['Int']['input']>
  scannedAmount: Scalars['Int']['input']
  isUnavailable?: InputMaybe<Scalars['Boolean']['input']>
  isSkip: Scalars['Boolean']['input']
  hubId: Scalars['String']['input']
  shopperCode: Scalars['String']['input']
  unavailablePickReasons?: InputMaybe<
    Array<_IUnavailablePickReasonsInput> | _IUnavailablePickReasonsInput
  >
  manualPickReasons?: InputMaybe<
    Array<_IManualPickReasonsInput> | _IManualPickReasonsInput
  >
  isIncorrectLocation?: InputMaybe<Scalars['Boolean']['input']>
}>

export type _IUpdatePickingItemMutation = {
  updatePickingItem: {
    __typename: 'PickingItem'
    id: string
    status: _IPickingItemStatus
    manualAmount: number
    scannedAmount: number
    skippedCount: number
    unavailableAmount: number
    isIncorrectLocation: boolean
    lineItem: {
      __typename: 'LineItem'
      sku: string
      name: string
      amount: number
      location: string
      totalAmountPerBox?: number | null
      barcodes: Array<string>
      imageUrl?: string | null
      tags: Array<string>
    }
    unavailablePickReasons: Array<{
      reason: _IUnavailablePickActionReason
      amount: number
    }>
    manualPickReasons: Array<{
      reason: _IManualPickActionReason
      amount: number
    }>
  }
}

export type _IGetAllHubsQueryVariables = Exact<{ [key: string]: never }>

export type _IGetAllHubsQuery = {
  allHubs?: Array<{ id: string; alias: string; isActive: boolean }> | null
}

export type _IGetCheckingItemsQueryVariables = Exact<{
  checkingId: Scalars['String']['input']
}>

export type _IGetCheckingItemsQuery = {
  checkingItems: Array<{
    __typename: 'CheckingItem'
    id: string
    status: _ICheckingItemStatus
    fulfilledAmount: number
    missingAmount: number
    exceededAmount: number
    lineItem: {
      __typename: 'LineItem'
      sku: string
      name: string
      amount: number
      location: string
      totalAmountPerBox?: number | null
      barcodes: Array<string>
      imageUrl?: string | null
      tags: Array<string>
    }
  }>
}

export type _IGetCheckingQueryVariables = Exact<{
  hubId: Scalars['String']['input']
  checkingId: Scalars['String']['input']
}>

export type _IGetCheckingQuery = {
  movementForChecking?: {
    __typename: 'Checking'
    id: string
    status: _ICheckingStatus
    movementId: string
    currentShopper?: { code: string } | null
    shoppers: Array<{ code: string; fullName: string }>
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      checkedAmount: number
      checkedItems: number
      unavailableItems: number
      totalAmount: number
      totalItems: number
      remainingItems: number
    }
  } | null
}

export type _IGetPaginatedDeliveriesQueryVariables = Exact<{
  currentPage: Scalars['Int']['input']
  perPage?: InputMaybe<Scalars['Int']['input']>
  hubId: Scalars['String']['input']
  orderId?: InputMaybe<Scalars['String']['input']>
  status: _IDeliveryStatus
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
}>

export type _IGetPaginatedDeliveriesQuery = {
  paginatedDeliveries?: {
    currentPage: number
    perPage: number
    totalOfPages: number
    total: number
    deliveries: Array<{
      __typename: 'Delivery'
      id: string
      status: _IDeliveryStatus
      orderId: string
      confirmedAt: any
      etaMin?: any | null
      etaMax?: any | null
      dispatch: boolean
      finishedAt?: any | null
      assortmentType: _IAssortmentType
      deliveryType: _IDeliveryType
      relatedDeliveries: Array<string>
      hasBags?: boolean | null
      lastPickUpdate?: any | null
      hub: { id: string; alias: string }
      customer: {
        name: string
        orderCount: number
        address: {
          formatted: string
          street: string
          number: string
          complement?: string | null
          neighborhood?: string | null
          city?: string | null
        }
      }
      rider?: { fullName: string; mode: _IRiderMode } | null
      shopper?: { fullName: string } | null
      statusHistory: Array<{
        statusFrom: string
        statusTo: string
        updatedAt?: any | null
      }>
      products: Array<{
        _id?: string | null
        name?: string | null
        sku?: string | null
        amount?: number | null
        location?: string | null
        barcodes?: Array<string> | null
        imageUrl?: string | null
        tags?: Array<string> | null
        salesforceId?: string | null
        scanningTime?: any | null
        scannedAmount?: number | null
        manuallyAmount?: number | null
        flaggedAmount?: number | null
        incorrectLocation?: boolean | null
        status: _IProductStatus
        flagged?: Array<{ reason: string; amount: number }> | null
        manually?: Array<{ reason: string; amount: number }> | null
      }>
      statusItems?: {
        total: number
        scanned: number
        manual: number
        flagged: number
        totalPicked: number
      } | null
      bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
      locationResume?: {
        totalOfRefrigerated?: number | null
        totalOfFrozen?: number | null
        totalOfRoomTemperature?: number | null
        totalOfFresh?: number | null
        location?: string | null
        shelves?: {
          fresh?: _ILocationResumeShelfStatus | null
          frozen?: _ILocationResumeShelfStatus | null
          refrigerated?: _ILocationResumeShelfStatus | null
          roomTemperature?: _ILocationResumeShelfStatus | null
        } | null
      } | null
    }>
  } | null
}

export type _IGetDeliveriesQueryVariables = Exact<{
  hubId: Scalars['String']['input']
}>

export type _IGetDeliveriesQuery = {
  deliveries?: Array<{
    __typename: 'Delivery'
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMin?: any | null
    etaMax?: any | null
    dispatch: boolean
    finishedAt?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hasBags?: boolean | null
    lastPickUpdate?: any | null
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
        city?: string | null
      }
    }
    rider?: { fullName: string; mode: _IRiderMode } | null
    shopper?: { fullName: string } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
    products: Array<{
      _id?: string | null
      name?: string | null
      sku?: string | null
      amount?: number | null
      location?: string | null
      barcodes?: Array<string> | null
      imageUrl?: string | null
      tags?: Array<string> | null
      salesforceId?: string | null
      scanningTime?: any | null
      scannedAmount?: number | null
      manuallyAmount?: number | null
      flaggedAmount?: number | null
      incorrectLocation?: boolean | null
      status: _IProductStatus
      flagged?: Array<{ reason: string; amount: number }> | null
      manually?: Array<{ reason: string; amount: number }> | null
    }>
    statusItems?: {
      total: number
      scanned: number
      manual: number
      flagged: number
      totalPicked: number
    } | null
    bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
    locationResume?: {
      totalOfRefrigerated?: number | null
      totalOfFrozen?: number | null
      totalOfRoomTemperature?: number | null
      totalOfFresh?: number | null
      location?: string | null
      shelves?: {
        fresh?: _ILocationResumeShelfStatus | null
        frozen?: _ILocationResumeShelfStatus | null
        refrigerated?: _ILocationResumeShelfStatus | null
        roomTemperature?: _ILocationResumeShelfStatus | null
      } | null
    } | null
  }> | null
}

export type _IGetDeliveryQueryVariables = Exact<{
  hubId: Scalars['String']['input']
  orderId: Scalars['String']['input']
}>

export type _IGetDeliveryQuery = {
  delivery?: {
    __typename: 'Delivery'
    id: string
    status: _IDeliveryStatus
    orderId: string
    confirmedAt: any
    etaMin?: any | null
    etaMax?: any | null
    dispatch: boolean
    finishedAt?: any | null
    assortmentType: _IAssortmentType
    deliveryType: _IDeliveryType
    relatedDeliveries: Array<string>
    hasBags?: boolean | null
    lastPickUpdate?: any | null
    hub: { id: string; alias: string }
    customer: {
      name: string
      orderCount: number
      address: {
        formatted: string
        street: string
        number: string
        complement?: string | null
        neighborhood?: string | null
        city?: string | null
      }
    }
    rider?: { fullName: string; mode: _IRiderMode } | null
    shopper?: { fullName: string } | null
    statusHistory: Array<{
      statusFrom: string
      statusTo: string
      updatedAt?: any | null
    }>
    products: Array<{
      _id?: string | null
      name?: string | null
      sku?: string | null
      amount?: number | null
      location?: string | null
      barcodes?: Array<string> | null
      imageUrl?: string | null
      tags?: Array<string> | null
      salesforceId?: string | null
      scanningTime?: any | null
      scannedAmount?: number | null
      manuallyAmount?: number | null
      flaggedAmount?: number | null
      incorrectLocation?: boolean | null
      status: _IProductStatus
      flagged?: Array<{ reason: string; amount: number }> | null
      manually?: Array<{ reason: string; amount: number }> | null
    }>
    statusItems?: {
      total: number
      scanned: number
      manual: number
      flagged: number
      totalPicked: number
    } | null
    bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
    locationResume?: {
      totalOfRefrigerated?: number | null
      totalOfFrozen?: number | null
      totalOfRoomTemperature?: number | null
      totalOfFresh?: number | null
      location?: string | null
      shelves?: {
        fresh?: _ILocationResumeShelfStatus | null
        frozen?: _ILocationResumeShelfStatus | null
        refrigerated?: _ILocationResumeShelfStatus | null
        roomTemperature?: _ILocationResumeShelfStatus | null
      } | null
    } | null
  } | null
}

export type _IGetHubsQueryVariables = Exact<{ [key: string]: never }>

export type _IGetHubsQuery = {
  hubs?: Array<{ id: string; alias: string; isActive: boolean }> | null
}

export type _IGetMovementDeliveryForPickingQueryVariables = Exact<{
  hubId: Scalars['String']['input']
  movementId: Scalars['String']['input']
}>

export type _IGetMovementDeliveryForPickingQuery = {
  movementForPicking?: {
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    reference?:
      | {
          __typename: 'ReferenceDelivery'
          id: string
          referenceType: _IReferenceType
          deliveryDetails: {
            id: string
            status: _IDeliveryStatus
            orderId: string
            confirmedAt: any
            etaMax?: any | null
            etaMin?: any | null
            assortmentType: _IAssortmentType
            deliveryType: _IDeliveryType
            relatedDeliveries: Array<string>
            hub: { id: string; alias: string }
            customer: {
              name: string
              orderCount: number
              address: {
                formatted: string
                street: string
                number: string
                complement?: string | null
                neighborhood?: string | null
              }
            }
            rider?: { fullName: string } | null
            shopper?: { fullName: string; code?: string | null } | null
            statusHistory: Array<{
              statusFrom: string
              statusTo: string
              updatedAt?: any | null
            }>
          }
        }
      | {}
      | null
    stats: { totalAmount: number; totalItems: number; fulfilledAmount: number }
  } | null
}

export type _IGetMovementForPickingQueryVariables = Exact<{
  hubId: Scalars['String']['input']
  movementId: Scalars['String']['input']
}>

export type _IGetMovementForPickingQuery = {
  movementForPicking?: {
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    checkingStatus: _IMovementPickingCheckStatus
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
  } | null
}

export type _IGetMovementPickingQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type _IGetMovementPickingQuery = {
  movementPicking: {
    __typename: 'Picking'
    id: string
    label: string
    status: _IPickingStatus
    shoppers: Array<{ fullName: string }>
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
    currentShopper?: { code: string } | null
  }
}

export type _IGetMovementsPickingsQueryVariables = Exact<{
  movementId: Scalars['String']['input']
}>

export type _IGetMovementsPickingsQuery = {
  movementPickings: Array<{
    id: string
    label: string
    status: _IPickingStatus
    shoppers: Array<{ fullName: string }>
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
    currentShopper?: { code: string } | null
  }>
}

export type _IGetMovementsDeliveriesPaginatedQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']['input']>
  orderId?: InputMaybe<Scalars['String']['input']>
  originHubId: Scalars['String']['input']
  status?: InputMaybe<Array<_IDeliveryStatus> | _IDeliveryStatus>
}>

export type _IGetMovementsDeliveriesPaginatedQuery = {
  movementsForPickingPaginated: {
    __typename: 'MovementsPaginated'
    currentPage: number
    perPage: number
    totalOfPages: number
    total: number
    movements: Array<{
      __typename: 'PickingMovement'
      id: string
      status: _IMovementStatus
      reference?:
        | {
            __typename: 'ReferenceDelivery'
            id: string
            referenceType: _IReferenceType
            deliveryDetails: {
              id: string
              status: _IDeliveryStatus
              orderId: string
              confirmedAt: any
              etaMax?: any | null
              etaMin?: any | null
              assortmentType: _IAssortmentType
              deliveryType: _IDeliveryType
              relatedDeliveries: Array<string>
              hub: { id: string; alias: string }
              customer: {
                name: string
                orderCount: number
                address: {
                  formatted: string
                  street: string
                  number: string
                  complement?: string | null
                  neighborhood?: string | null
                }
              }
              rider?: { fullName: string } | null
              shopper?: { fullName: string; code?: string | null } | null
              statusHistory: Array<{
                statusFrom: string
                statusTo: string
                updatedAt?: any | null
              }>
            }
          }
        | {}
        | null
      stats: {
        totalAmount: number
        totalItems: number
        fulfilledAmount: number
      }
    }>
  }
}

export type _IGetMovementsDeliveriesQueryVariables = Exact<{
  hubId: Scalars['String']['input']
  deliveryStatuses?: InputMaybe<Array<_IDeliveryStatus> | _IDeliveryStatus>
}>

export type _IGetMovementsDeliveriesQuery = {
  movementsForPicking?: Array<{
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    reference?:
      | {
          __typename: 'ReferenceDelivery'
          id: string
          referenceType: _IReferenceType
          deliveryDetails: {
            id: string
            status: _IDeliveryStatus
            orderId: string
            confirmedAt: any
            etaMax?: any | null
            etaMin?: any | null
            assortmentType: _IAssortmentType
            deliveryType: _IDeliveryType
            relatedDeliveries: Array<string>
            hub: { id: string; alias: string }
            customer: {
              name: string
              orderCount: number
              address: {
                formatted: string
                street: string
                number: string
                complement?: string | null
                neighborhood?: string | null
              }
            }
            rider?: { fullName: string } | null
            shopper?: { fullName: string; code?: string | null } | null
            statusHistory: Array<{
              statusFrom: string
              statusTo: string
              updatedAt?: any | null
            }>
          }
        }
      | {}
      | null
    stats: { totalAmount: number; totalItems: number; fulfilledAmount: number }
  }> | null
}

export type _IGetMovementsForCheckingQueryVariables = Exact<{
  originHubId: Scalars['String']['input']
  referenceId?: InputMaybe<Scalars['String']['input']>
  hubDestinationId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<_ICheckingStatus> | _ICheckingStatus>
  currentPage?: InputMaybe<Scalars['Int']['input']>
}>

export type _IGetMovementsForCheckingQuery = {
  movementsForCheckingPaginated: {
    __typename: 'MovementsForCheckingPaginated'
    currentPage: number
    perPage: number
    totalOfPages: number
    total: number
    checkings: Array<{
      __typename: 'Checking'
      id: string
      status: _ICheckingStatus
      movementId: string
      currentShopper?: { code: string } | null
      shoppers: Array<{ code: string; fullName: string }>
      reference?:
        | {
            id: string
            referenceType: _IReferenceType
            kind: _ITransferOrderKind
            storageType: _ITransferOrderStorageType
            destination: { id: string; name: string }
          }
        | {}
        | null
      stats: {
        checkedAmount: number
        checkedItems: number
        unavailableItems: number
        totalAmount: number
        totalItems: number
        remainingItems: number
      }
    }>
  }
}

export type _IGetMovementsForPickingQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']['input']>
  referenceId?: InputMaybe<Scalars['String']['input']>
  hubDestinationId?: InputMaybe<Scalars['String']['input']>
  originHubId: Scalars['String']['input']
}>

export type _IGetMovementsForPickingQuery = {
  movementsForPickingPaginated: {
    __typename: 'MovementsPaginated'
    currentPage: number
    perPage: number
    totalOfPages: number
    total: number
    movements: Array<{
      __typename: 'PickingMovement'
      id: string
      status: _IMovementStatus
      checkingStatus: _IMovementPickingCheckStatus
      reference?:
        | {
            id: string
            referenceType: _IReferenceType
            kind: _ITransferOrderKind
            storageType: _ITransferOrderStorageType
            destination: { id: string; name: string }
          }
        | {}
        | null
      stats: {
        fulfilledAmount: number
        totalAmount: number
        startedItems: number
        unavailableItems: number
        totalItems: number
      }
    }>
  }
}

export type _IGetPickingItemsQueryVariables = Exact<{
  pickingId?: InputMaybe<Scalars['String']['input']>
  movementId: Scalars['String']['input']
}>

export type _IGetPickingItemsQuery = {
  pickingItems: Array<{
    __typename: 'PickingItem'
    id: string
    status: _IPickingItemStatus
    manualAmount: number
    scannedAmount: number
    skippedCount: number
    unavailableAmount: number
    isIncorrectLocation: boolean
    lineItem: {
      __typename: 'LineItem'
      sku: string
      name: string
      amount: number
      location: string
      totalAmountPerBox?: number | null
      barcodes: Array<string>
      imageUrl?: string | null
      tags: Array<string>
    }
    unavailablePickReasons: Array<{
      reason: _IUnavailablePickActionReason
      amount: number
    }>
    manualPickReasons: Array<{
      reason: _IManualPickActionReason
      amount: number
    }>
  }>
}

export type _IGetPaginatedDeliveriesByEtaQueryVariables = Exact<{
  currentPage: Scalars['Int']['input']
  perPage?: InputMaybe<Scalars['Int']['input']>
  hubId: Scalars['String']['input']
  status: _IDeliveryStatus
  etaStartDate?: InputMaybe<Scalars['DateTime']['input']>
  etaEndDate?: InputMaybe<Scalars['DateTime']['input']>
  deliveryType: _IDeliveryType
  assortmentType: _IAssortmentType
}>

export type _IGetPaginatedDeliveriesByEtaQuery = {
  paginatedDeliveriesByEta?: {
    currentPage: number
    perPage: number
    totalOfPages: number
    total: number
    deliveries: Array<{
      __typename: 'Delivery'
      id: string
      status: _IDeliveryStatus
      orderId: string
      confirmedAt: any
      etaMin?: any | null
      etaMax?: any | null
      dispatch: boolean
      finishedAt?: any | null
      assortmentType: _IAssortmentType
      deliveryType: _IDeliveryType
      relatedDeliveries: Array<string>
      hasBags?: boolean | null
      lastPickUpdate?: any | null
      hub: { id: string; alias: string }
      customer: {
        name: string
        orderCount: number
        address: {
          formatted: string
          street: string
          number: string
          complement?: string | null
          neighborhood?: string | null
          city?: string | null
        }
      }
      rider?: { fullName: string; mode: _IRiderMode } | null
      shopper?: { fullName: string } | null
      statusHistory: Array<{
        statusFrom: string
        statusTo: string
        updatedAt?: any | null
      }>
      products: Array<{
        _id?: string | null
        name?: string | null
        sku?: string | null
        amount?: number | null
        location?: string | null
        barcodes?: Array<string> | null
        imageUrl?: string | null
        tags?: Array<string> | null
        salesforceId?: string | null
        scanningTime?: any | null
        scannedAmount?: number | null
        manuallyAmount?: number | null
        flaggedAmount?: number | null
        incorrectLocation?: boolean | null
        status: _IProductStatus
        flagged?: Array<{ reason: string; amount: number }> | null
        manually?: Array<{ reason: string; amount: number }> | null
      }>
      statusItems?: {
        total: number
        scanned: number
        manual: number
        flagged: number
        totalPicked: number
      } | null
      bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
      locationResume?: {
        totalOfRefrigerated?: number | null
        totalOfFrozen?: number | null
        totalOfRoomTemperature?: number | null
        totalOfFresh?: number | null
        location?: string | null
        shelves?: {
          fresh?: _ILocationResumeShelfStatus | null
          frozen?: _ILocationResumeShelfStatus | null
          refrigerated?: _ILocationResumeShelfStatus | null
          roomTemperature?: _ILocationResumeShelfStatus | null
        } | null
      } | null
    }>
  } | null
}

export type _ILiveCheckingItemsUpdatedSubscriptionVariables = Exact<{
  checkingId: Scalars['String']['input']
}>

export type _ILiveCheckingItemsUpdatedSubscription = {
  liveMovementCheckingItemUpdated: {
    event: string
    checkingItem: {
      __typename: 'CheckingItem'
      id: string
      status: _ICheckingItemStatus
      fulfilledAmount: number
      missingAmount: number
      exceededAmount: number
      lineItem: {
        __typename: 'LineItem'
        sku: string
        name: string
        amount: number
        location: string
        totalAmountPerBox?: number | null
        barcodes: Array<string>
        imageUrl?: string | null
        tags: Array<string>
      }
    }
  }
}

export type _ILiveCheckingUpdatedSubscriptionVariables = Exact<{
  checkingId: Scalars['String']['input']
}>

export type _ILiveCheckingUpdatedSubscription = {
  liveMovementCheckingUpdated: {
    __typename: 'Checking'
    id: string
    status: _ICheckingStatus
    movementId: string
    currentShopper?: { code: string } | null
    shoppers: Array<{ code: string; fullName: string }>
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      checkedAmount: number
      checkedItems: number
      unavailableItems: number
      totalAmount: number
      totalItems: number
      remainingItems: number
    }
  }
}

export type _ILiveDeliveriesUpdatedSubscriptionVariables = Exact<{
  hubId: Scalars['String']['input']
}>

export type _ILiveDeliveriesUpdatedSubscription = {
  liveDeliveriesUpdated: {
    event: string
    delivery: {
      __typename: 'Delivery'
      id: string
      status: _IDeliveryStatus
      orderId: string
      confirmedAt: any
      etaMin?: any | null
      etaMax?: any | null
      dispatch: boolean
      finishedAt?: any | null
      assortmentType: _IAssortmentType
      deliveryType: _IDeliveryType
      relatedDeliveries: Array<string>
      hasBags?: boolean | null
      lastPickUpdate?: any | null
      hub: { id: string; alias: string }
      customer: {
        name: string
        orderCount: number
        address: {
          formatted: string
          street: string
          number: string
          complement?: string | null
          neighborhood?: string | null
          city?: string | null
        }
      }
      rider?: { fullName: string; mode: _IRiderMode } | null
      shopper?: { fullName: string } | null
      statusHistory: Array<{
        statusFrom: string
        statusTo: string
        updatedAt?: any | null
      }>
      products: Array<{
        _id?: string | null
        name?: string | null
        sku?: string | null
        amount?: number | null
        location?: string | null
        barcodes?: Array<string> | null
        imageUrl?: string | null
        tags?: Array<string> | null
        salesforceId?: string | null
        scanningTime?: any | null
        scannedAmount?: number | null
        manuallyAmount?: number | null
        flaggedAmount?: number | null
        incorrectLocation?: boolean | null
        status: _IProductStatus
        flagged?: Array<{ reason: string; amount: number }> | null
        manually?: Array<{ reason: string; amount: number }> | null
      }>
      statusItems?: {
        total: number
        scanned: number
        manual: number
        flagged: number
        totalPicked: number
      } | null
      bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
      locationResume?: {
        totalOfRefrigerated?: number | null
        totalOfFrozen?: number | null
        totalOfRoomTemperature?: number | null
        totalOfFresh?: number | null
        location?: string | null
        shelves?: {
          fresh?: _ILocationResumeShelfStatus | null
          frozen?: _ILocationResumeShelfStatus | null
          refrigerated?: _ILocationResumeShelfStatus | null
          roomTemperature?: _ILocationResumeShelfStatus | null
        } | null
      } | null
    }
  }
}

export type _IDeliveryUpdatedSubscriptionVariables = Exact<{
  hubId: Scalars['String']['input']
}>

export type _IDeliveryUpdatedSubscription = {
  liveDeliveriesUpdated: {
    event: string
    delivery: {
      __typename: 'Delivery'
      id: string
      status: _IDeliveryStatus
      orderId: string
      confirmedAt: any
      etaMin?: any | null
      etaMax?: any | null
      dispatch: boolean
      finishedAt?: any | null
      assortmentType: _IAssortmentType
      deliveryType: _IDeliveryType
      relatedDeliveries: Array<string>
      hasBags?: boolean | null
      lastPickUpdate?: any | null
      hub: { id: string; alias: string }
      customer: {
        name: string
        orderCount: number
        address: {
          formatted: string
          street: string
          number: string
          complement?: string | null
          neighborhood?: string | null
          city?: string | null
        }
      }
      rider?: { fullName: string; mode: _IRiderMode } | null
      shopper?: { fullName: string } | null
      statusHistory: Array<{
        statusFrom: string
        statusTo: string
        updatedAt?: any | null
      }>
      products: Array<{
        _id?: string | null
        name?: string | null
        sku?: string | null
        amount?: number | null
        location?: string | null
        barcodes?: Array<string> | null
        imageUrl?: string | null
        tags?: Array<string> | null
        salesforceId?: string | null
        scanningTime?: any | null
        scannedAmount?: number | null
        manuallyAmount?: number | null
        flaggedAmount?: number | null
        incorrectLocation?: boolean | null
        status: _IProductStatus
        flagged?: Array<{ reason: string; amount: number }> | null
        manually?: Array<{ reason: string; amount: number }> | null
      }>
      statusItems?: {
        total: number
        scanned: number
        manual: number
        flagged: number
        totalPicked: number
      } | null
      bags?: Array<{ type: _IBagType; size: _IBagSize; amount: number }> | null
      locationResume?: {
        totalOfRefrigerated?: number | null
        totalOfFrozen?: number | null
        totalOfRoomTemperature?: number | null
        totalOfFresh?: number | null
        location?: string | null
        shelves?: {
          fresh?: _ILocationResumeShelfStatus | null
          frozen?: _ILocationResumeShelfStatus | null
          refrigerated?: _ILocationResumeShelfStatus | null
          roomTemperature?: _ILocationResumeShelfStatus | null
        } | null
      } | null
    }
  }
}

export type _ILiveMovementCheckingItemListUpdatedSubscriptionVariables = Exact<{
  checkingId: Scalars['String']['input']
}>

export type _ILiveMovementCheckingItemListUpdatedSubscription = {
  liveMovementCheckingItemListUpdated: {
    event: string
    checkingItem: {
      __typename: 'CheckingItem'
      id: string
      status: _ICheckingItemStatus
      fulfilledAmount: number
      missingAmount: number
      exceededAmount: number
      lineItem: {
        __typename: 'LineItem'
        sku: string
        name: string
        amount: number
        location: string
        totalAmountPerBox?: number | null
        barcodes: Array<string>
        imageUrl?: string | null
        tags: Array<string>
      }
    }
  }
}

export type _ILiveMovementCheckingListUpdatedSubscriptionVariables = Exact<{
  originHubId: Scalars['String']['input']
}>

export type _ILiveMovementCheckingListUpdatedSubscription = {
  liveMovementCheckingListUpdated: {
    event: string
    checking: {
      __typename: 'Checking'
      id: string
      status: _ICheckingStatus
      movementId: string
      currentShopper?: { code: string } | null
      shoppers: Array<{ code: string; fullName: string }>
      reference?:
        | {
            id: string
            referenceType: _IReferenceType
            kind: _ITransferOrderKind
            storageType: _ITransferOrderStorageType
            destination: { id: string; name: string }
          }
        | {}
        | null
      stats: {
        checkedAmount: number
        checkedItems: number
        unavailableItems: number
        totalAmount: number
        totalItems: number
        remainingItems: number
      }
    }
  }
}

export type _ILiveMovementDeliveryUpdatedSubscriptionVariables = Exact<{
  movementId: Scalars['String']['input']
}>

export type _ILiveMovementDeliveryUpdatedSubscription = {
  liveMovementUpdated: {
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    reference?:
      | {
          __typename: 'ReferenceDelivery'
          id: string
          referenceType: _IReferenceType
          deliveryDetails: {
            id: string
            status: _IDeliveryStatus
            orderId: string
            confirmedAt: any
            etaMax?: any | null
            etaMin?: any | null
            assortmentType: _IAssortmentType
            deliveryType: _IDeliveryType
            relatedDeliveries: Array<string>
            hub: { id: string; alias: string }
            customer: {
              name: string
              orderCount: number
              address: {
                formatted: string
                street: string
                number: string
                complement?: string | null
                neighborhood?: string | null
              }
            }
            rider?: { fullName: string } | null
            shopper?: { fullName: string; code?: string | null } | null
            statusHistory: Array<{
              statusFrom: string
              statusTo: string
              updatedAt?: any | null
            }>
          }
        }
      | {}
      | null
    stats: { totalAmount: number; totalItems: number; fulfilledAmount: number }
  }
}

export type _ILiveMovementUpdatedSubscriptionVariables = Exact<{
  movementId: Scalars['String']['input']
}>

export type _ILiveMovementUpdatedSubscription = {
  liveMovementUpdated: {
    __typename: 'PickingMovement'
    id: string
    status: _IMovementStatus
    checkingStatus: _IMovementPickingCheckStatus
    reference?:
      | {
          id: string
          referenceType: _IReferenceType
          kind: _ITransferOrderKind
          storageType: _ITransferOrderStorageType
          destination: { id: string; name: string }
        }
      | {}
      | null
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
  }
}

export type _ILiveMovementPickingItemListUpdatedSubscriptionVariables = Exact<{
  pickingId: Scalars['String']['input']
}>

export type _ILiveMovementPickingItemListUpdatedSubscription = {
  liveMovementPickingItemListUpdated: {
    event: string
    pickingItem: {
      __typename: 'PickingItem'
      id: string
      status: _IPickingItemStatus
      manualAmount: number
      scannedAmount: number
      skippedCount: number
      unavailableAmount: number
      isIncorrectLocation: boolean
      lineItem: {
        __typename: 'LineItem'
        sku: string
        name: string
        amount: number
        location: string
        totalAmountPerBox?: number | null
        barcodes: Array<string>
        imageUrl?: string | null
        tags: Array<string>
      }
      unavailablePickReasons: Array<{
        reason: _IUnavailablePickActionReason
        amount: number
      }>
      manualPickReasons: Array<{
        reason: _IManualPickActionReason
        amount: number
      }>
    }
  }
}

export type _ILiveMovementPickingListUpdatedSubscriptionVariables = Exact<{
  movementId: Scalars['String']['input']
}>

export type _ILiveMovementPickingListUpdatedSubscription = {
  liveMovementPickingListUpdated: {
    __typename: 'Picking'
    id: string
    label: string
    status: _IPickingStatus
    shoppers: Array<{ fullName: string }>
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
    currentShopper?: { code: string } | null
  }
}

export type _ILiveMovementPickingUpdatedSubscriptionVariables = Exact<{
  id: Scalars['String']['input']
}>

export type _ILiveMovementPickingUpdatedSubscription = {
  liveMovementPickingUpdated: {
    __typename: 'Picking'
    id: string
    label: string
    status: _IPickingStatus
    shoppers: Array<{ fullName: string }>
    stats: {
      fulfilledAmount: number
      totalAmount: number
      startedItems: number
      unavailableItems: number
      totalItems: number
    }
    currentShopper?: { code: string } | null
  }
}

export type _ILiveMovementDeliveryListUpdatedSubscriptionVariables = Exact<{
  originHubId: Scalars['String']['input']
}>

export type _ILiveMovementDeliveryListUpdatedSubscription = {
  liveMovementListUpdated: {
    event: string
    movement: {
      __typename: 'PickingMovement'
      id: string
      status: _IMovementStatus
      reference?:
        | {
            __typename: 'ReferenceDelivery'
            id: string
            referenceType: _IReferenceType
            deliveryDetails: {
              id: string
              status: _IDeliveryStatus
              orderId: string
              confirmedAt: any
              etaMax?: any | null
              etaMin?: any | null
              assortmentType: _IAssortmentType
              deliveryType: _IDeliveryType
              relatedDeliveries: Array<string>
              hub: { id: string; alias: string }
              customer: {
                name: string
                orderCount: number
                address: {
                  formatted: string
                  street: string
                  number: string
                  complement?: string | null
                  neighborhood?: string | null
                }
              }
              rider?: { fullName: string } | null
              shopper?: { fullName: string; code?: string | null } | null
              statusHistory: Array<{
                statusFrom: string
                statusTo: string
                updatedAt?: any | null
              }>
            }
          }
        | {}
        | null
      stats: {
        totalAmount: number
        totalItems: number
        fulfilledAmount: number
      }
    }
  }
}

export type _ILiveMovementListUpdatedSubscriptionVariables = Exact<{
  originHubId: Scalars['String']['input']
}>

export type _ILiveMovementListUpdatedSubscription = {
  liveMovementListUpdated: {
    event: string
    movement: {
      __typename: 'PickingMovement'
      id: string
      status: _IMovementStatus
      checkingStatus: _IMovementPickingCheckStatus
      reference?:
        | {
            id: string
            referenceType: _IReferenceType
            kind: _ITransferOrderKind
            storageType: _ITransferOrderStorageType
            destination: { id: string; name: string }
          }
        | {}
        | null
      stats: {
        fulfilledAmount: number
        totalAmount: number
        startedItems: number
        unavailableItems: number
        totalItems: number
      }
    }
  }
}
